var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-card", staticStyle: { "min-height": "750px" } },
        [
          _vm._m(0),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c(
                "b-field",
                [
                  _c("multiselect", {
                    staticStyle: { "min-width": "400px" },
                    attrs: {
                      options: _vm.customers,
                      multiple: false,
                      "close-on-select": true,
                      placeholder: "Pick customer shipped to...",
                      "custom-label": (obj) => obj.id + " - " + obj.name,
                      "track-by": "name",
                    },
                    model: {
                      value: _vm.selectedCustomer,
                      callback: function ($$v) {
                        _vm.selectedCustomer = $$v
                      },
                      expression: "selectedCustomer",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c("multiselect", {
                    staticStyle: { "min-width": "400px" },
                    attrs: {
                      options: _vm.customers,
                      multiple: false,
                      "close-on-select": true,
                      placeholder: "Pick customer sold to...",
                      "custom-label": (obj) => obj.id + " - " + obj.name,
                      "track-by": "name",
                    },
                    model: {
                      value: _vm.selectedCustomerSoldTo,
                      callback: function ($$v) {
                        _vm.selectedCustomerSoldTo = $$v
                      },
                      expression: "selectedCustomerSoldTo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c("b-datepicker", {
                    attrs: {
                      name: "date",
                      icon: "calendar-alt",
                      placeholder: "End date",
                      "date-formatter": (date) =>
                        _vm.$dayjs(date).format("DD/MM/YYYY"),
                    },
                    model: {
                      value: _vm.reportEndDate,
                      callback: function ($$v) {
                        _vm.reportEndDate = $$v
                      },
                      expression: "reportEndDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c("input", {
                    attrs: {
                      id: "fileUpload",
                      type: "file",
                      accept: ".csv",
                      hidden: "",
                    },
                    on: { change: _vm.loadTextFromFile },
                  }),
                  _c(
                    "b-button",
                    { staticClass: "btn", on: { click: _vm.chooseFiles } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("pages.customer_forecast.upload_csv")) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "is-primary" },
                      on: { click: _vm.getTemplate },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("pages.customer_forecast.get_csv_template")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c(
                    "b-message",
                    {
                      attrs: {
                        type: "is-success",
                        "aria-close-label": "Close message",
                      },
                      model: {
                        value: _vm.isActive,
                        callback: function ($$v) {
                          _vm.isActive = $$v
                        },
                        expression: "isActive",
                      },
                    },
                    [_vm._v(" The file looks good ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "footer",
            { staticClass: "modal-card-foot" },
            [
              _c(
                "b-field",
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        position: "is-right",
                        type: "is-info",
                        "icon-left": "play",
                        "native-type": "submit",
                        disabled: _vm.isDisabled(),
                      },
                    },
                    [_vm._v(" Send ")]
                  ),
                  _c(
                    "b-checkbox",
                    {
                      model: {
                        value: _vm.nothing,
                        callback: function ($$v) {
                          _vm.nothing = $$v
                        },
                        expression: "nothing",
                      },
                    },
                    [_vm._v(" Nothing to declare ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v(" Stock validation "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }